module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Fagus/Tokyo_Fagus_MRI_RCP26_Mid.png";